module.exports = __webpack_public_path__ + "img/logo1.a7b6c372.png";